/**
 * @generated SignedSource<<2faa55aaf83080a9a0bd65da2b391580>>
 * @relayHash 050bd6257cd654aa33031df385965839
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec1864e69d3ec4afe8d7adfac82c98263514df8ed7fcc874a002d909a1ac2313

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "operationType"
    },
    v3 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageAri"
    },
    v4 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v5 = {
      "kind": "Variable",
      "name": "operationType",
      "variableName": "operationType"
    },
    v6 = [{
      "kind": "Variable",
      "name": "ari",
      "variableName": "hubAri"
    }, v5 /*: any*/],
    v7 = {
      "kind": "ScalarField",
      "name": "asapIssuer"
    },
    v8 = {
      "kind": "ScalarField",
      "name": "mediaCollectionName"
    },
    v9 = {
      "kind": "ScalarField",
      "name": "mediaToken"
    },
    v10 = {
      "kind": "ScalarField",
      "name": "mediaUrl"
    },
    v11 = [{
      "kind": "Variable",
      "name": "ari",
      "variableName": "pageAri"
    }, v5 /*: any*/],
    v12 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "hubAri"
    }],
    v13 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterLogo",
          "kind": "LinkedField",
          "name": "logo",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "fileId"
          }, {
            "kind": "ScalarField",
            "name": "url"
          }]
        }, {
          "concreteType": "HelpCenterBrandingColors",
          "kind": "LinkedField",
          "name": "colors",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "primary"
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v14 = [v7 /*: any*/, v8 /*: any*/, v9 /*: any*/, v10 /*: any*/];
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/],
      "kind": "Fragment",
      "name": "hubBootstrapQuery",
      "selections": [{
        "args": v4 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "kind": "RequiredField",
          "field": {
            "args": v6 /*: any*/,
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": [{
              "kind": "RequiredField",
              "field": v7 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.hubMediaConfig.asapIssuer"
            }, {
              "kind": "RequiredField",
              "field": v8 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.hubMediaConfig.mediaCollectionName"
            }, {
              "kind": "RequiredField",
              "field": v9 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.hubMediaConfig.mediaToken"
            }, {
              "kind": "RequiredField",
              "field": v10 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.hubMediaConfig.mediaUrl"
            }]
          },
          "action": "THROW",
          "path": "helpCenter.hubMediaConfig"
        }, {
          "kind": "RequiredField",
          "field": {
            "alias": "pageMediaConfig",
            "args": v11 /*: any*/,
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": [{
              "kind": "RequiredField",
              "field": v7 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.pageMediaConfig.asapIssuer"
            }, {
              "kind": "RequiredField",
              "field": v8 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.pageMediaConfig.mediaCollectionName"
            }, {
              "kind": "RequiredField",
              "field": v9 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.pageMediaConfig.mediaToken"
            }, {
              "kind": "RequiredField",
              "field": v10 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.pageMediaConfig.mediaUrl"
            }]
          },
          "action": "THROW",
          "path": "helpCenter.pageMediaConfig"
        }, {
          "args": v12 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v13 /*: any*/]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v3 /*: any*/, v2 /*: any*/],
      "kind": "Operation",
      "name": "hubBootstrapQuery",
      "selections": [{
        "args": v4 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v6 /*: any*/,
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": v14 /*: any*/
        }, {
          "alias": "pageMediaConfig",
          "args": v11 /*: any*/,
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": v14 /*: any*/
        }, {
          "args": v12 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "__typename"
          }, v13 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }]
    },
    "params": {
      "id": "ec1864e69d3ec4afe8d7adfac82c98263514df8ed7fcc874a002d909a1ac2313",
      "metadata": {},
      "name": "hubBootstrapQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "c680574a290e6ea711e06b42469f0eb9";
export default node;